import dayjs from "dayjs";
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

export function formatDate(date = new Date(), format = "DD-MM-YYYY, HH:mm A") {
  return dayjs(date).format(format);
}
